<div class="card m-3">
  <div class="card-header text-center">
    <h2>401</h2>
  </div>
  <div class="card-body text-center">
    <p>Din session er udløbet - log venligst ind igen</p>
  </div>
</div>
